import 'ui-core/plugins/sticko/js/sticko';

(function () {
    var sticko = UX.sticko;

    sticko.get.fixedpageElementsHeight = function () {
        let elementsHeight = $('header, .pageHeader').outerHeight();

        if (!elementsHeight) {
            elementsHeight = 0;
        }
        return elementsHeight;
    };

    sticko.set.height = function (val, originalHeight) {
        let offestYTop = window.pageYOffset; // get windows y-top offset
        let offsetBottom = offestYTop + $(window).outerHeight(); // get windows y-bottom offset
        let footerHeight = $('.page-footer').outerHeight();
        let fixedArea = $(document).outerHeight() - footerHeight; // get break point for stickiness

        let styles = {}; // define styles varibale

        if (offsetBottom >= fixedArea) {
            // check of we reached break point
            val = offsetBottom - fixedArea; // get new height
            sticko.newHeight = originalHeight - val;
            styles = {
                height: sticko.newHeight, // store new height
            };
        } else {
            styles = {
                height: originalHeight, // reset original height
            };
        }
        sticko.apply(sticko.$child, styles); // apply new height

        let hHeight = sticko.get.fixedpageElementsHeight();

        if ($('.article-row-left').outerHeight() < $(window).outerHeight()) {
            if (!UX.accordion.isArticleAccordion) {
                $('.article-row-left').height($(window).outerHeight() - hHeight);
            }
        }

        if ($('.dynamic-sticko').length) {
            $('.dynamic-sticko').each(function () {
                let dynamicStickyElement = $(this);
                dynamicStickyElement.css({
                    position: 'static',
                    'padding-bottom': '',
                });
                let dynamicScrollTop = $(window).scrollTop() + hHeight;
                let dynamicHeight = $(window).outerHeight() - hHeight;
                let dynamicChildHeight = dynamicHeight;

                if (dynamicStickyElement.find('.tab__nav').length) {
                    dynamicChildHeight -= dynamicStickyElement.find('.tab__nav').outerHeight();
                }

                if (offsetBottom >= fixedArea) {
                    // check of we reached break point
                    val = offsetBottom - fixedArea; // get new height
                    dynamicStickyElement.css('height', dynamicHeight - val);
                    $('.sticko__child').css('height', dynamicChildHeight - val);
                } else {
                    dynamicStickyElement.css('height', dynamicHeight);
                    $('.sticko__child').css('height', dynamicChildHeight);
                }

                if (dynamicScrollTop >= dynamicStickyElement.offset().top) {
                    $('.sticko__parent').css('padding-bottom', dynamicHeight);
                    dynamicStickyElement.css({
                        position: 'fixed',
                        top: hHeight,
                    });
                }
            });
        }
    };
})();
